var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
define('areas/navigationmanager/parts/loadmodulelocks',["require", "exports", "common/parts", "services/httpclient"], function (require, exports, Parts, Http) {
    "use strict";
    var LoadModuleLocks = (function (_super) {
        __extends(LoadModuleLocks, _super);
        function LoadModuleLocks() {
            _super.apply(this, arguments);
        }
        LoadModuleLocks.prototype.process = function (symbol) {
            var _this = this;
            var service = new Http.Channel();
            service.getDataAsync("/api/networkmember/{memberId}/locks".replace("{memberId}", symbol), Http.ServiceTarget.portalApi)
                .then(function (response) {
                _this.output.call(response);
            })
                .fail(function (error) {
                _this.error.call(error);
            });
        };
        return LoadModuleLocks;
    }(Parts.Part));
    return LoadModuleLocks;
});

